import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { generateURL } from '../../utils/utils';
import useLog from '../../utils/hooks/useLog';
import usePay from '../../utils/hooks/usePay';
import { scrollSave } from '../../actions/game';

export default ({
  children,
  to,
  info,
  source,
  data = {},
  logInfo: { category, action, params = {}, bizInfo } = {},
  ...extProps
}) => {
  const dispatch = useDispatch();
  const [report, track] = useLog();
  const pay = usePay();
  // eslint-disable-next-line no-param-reassign
  to = to || generateURL(info);

  // eslint-disable-next-line no-underscore-dangle
  const _DataReport = () => {
    report(category, action, params, bizInfo);
  };

  if (to.external) {
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      <a href={to.url} target="_blank" {...extProps} onClick={_DataReport}>
        {children}
      </a>
    );
  }

  if (to.pay) {
    return (
      <a
        {...extProps}
        onClick={e => {
          e.preventDefault();
          _DataReport();
          pay(to.url, source, data);
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to.url}
      {...extProps}
      onClick={() => {
        _DataReport();
        track(2, source);
        dispatch(scrollSave());
      }}
    >
      {children}
    </Link>
  );
};
